export enum ParticipantStatus{
    PENDING="Pending",
    DISCONNECTED="Disconnected",
    PARTICIPANT_CONNECTED="Participant Connected",
    PARTICIPANT_DISCONNECTED="Participant Disconnected",
    PARTICIPANT_RECONNECTED="Participant Reconnected",
    PARTICIPANT_RECONNECTING="Participant Reconnecting",
    RECONNECTED="Reconnected",
    RECONNECTING="Reconnecting",

}